import { render, staticRenderFns } from "./NsTabBar.vue?vue&type=template&id=f2a7320c&scoped=true"
import script from "./NsTabBar.vue?vue&type=script&lang=js"
export * from "./NsTabBar.vue?vue&type=script&lang=js"
import style0 from "./NsTabBar.vue?vue&type=style&index=0&id=f2a7320c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a7320c",
  null
  
)

export default component.exports